<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" :title="'SLA Files: ' + title" @back="back">
            <a-skeleton :loading="loading" active>
                <a-descriptions bordered>
                    <a-descriptions-item label="Nama">
                        <strong>{{ userInfo.name }}</strong>
                    </a-descriptions-item>
                    <a-descriptions-item label="Gender">
                        <strong>{{ gender(userInfo.gender) }}</strong>
                    </a-descriptions-item>
                    <a-descriptions-item label="Email">
                        <strong>{{ userInfo.email }}</strong>
                    </a-descriptions-item>
                </a-descriptions>
            </a-skeleton>
        </a-page-header>

        <a-card type="inner" size="small">
            <a-table
                class="pcp-table"
                :dataSource="items.files"
                rowKey="id"
                :pagination="false"
                :loading="loading"
                bordered>

                <a-table-column key="Bimbingan" title="Bimbingan Ke" className="align-center text-small text-center">
                    <template slot-scope="text, record, index">
                        {{ (index+1) }}
                    </template>
                </a-table-column>

                <a-table-column key="upload_time" title="Waktu Upload" className="align-center text-small text-center">
                    <template slot-scope="record">
                        <div v-if="record.created_at">
                            {{ moment(record.created_at).format('DD-MM-YYYY HH:mm:ss') }}
                        </div>
                    </template>
                </a-table-column>

                <a-table-column key="response_mentor" title="Waktu Respon Mentor" className="align-center text-small text-center">
                    <template slot-scope="record">
                        {{ record.response_time_mentor }}
                    </template>
                </a-table-column>

                <!--<a-table-column key="approval_mentor" title="Waktu Approval Mentor" className="align-center text-small text-center">
                    <template slot-scope="record">
                        {{ record.approved_time1 }}
                    </template>
                </a-table-column>-->

                <a-table-column key="sla_mentor" title="SLA Mentor" className="align-center text-small text-center">
                    <template slot-scope="record">
                        {{ record.diff_response_mentor }}
                    </template>
                </a-table-column>

                <a-table-column key="response_advisor" title="Waktu Respon Pembimbing" className="align-center text-small text-center">
                    <template slot-scope="record">
                        {{ record.response_time }}
                    </template>
                </a-table-column>

                <!--<a-table-column key="approval_advisor" title="Waktu Approval Pembimbing" className="align-center text-small text-center">
                    <template slot-scope="record">
                        {{ record.approved_time2 }}
                    </template>
                </a-table-column>-->

                <a-table-column key="sla_advisor" title="SLA Pembimbing" className="align-center text-small text-center">
                    <template slot-scope="record">
                        {{ record.diff_response_advisor }}
                    </template>
                </a-table-column>

            </a-table>
        </a-card>
    </div>
</template>

<script>
export default {
    props: {
        outline: {
            type: String,
            required: true
        },
        module: {
            type: String,
            default: 'paper'
        },
        activity: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            items: {
                outline: {
                    title: ''
                },
                attendant: {
                    name: '',
                    email: '',
                    gender: '',
                }
            },
            loading: false,
            processing: false,
        }
    },
    created() {
        this.getItems()
    },
    computed: {
        activeModule() {
            return this.$laravel.active_module
        },
        title(){
            return this.items.outline.title
        },
        userInfo(){
            return this.items.attendant
        }
    },
    methods: {
        getItems() {
            this.loading = true;

            let params = {
                module: this.module,
                activity: this.activity
            }

            this.$http
                .get(this.routeUri("api.report.sla.files", {outline: this.outline}) + '?' + this.$qs.stringify(params))
                .then(response => this.items = response.data)
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        back() {
            window.history.back();
        },
        gender(gender){
            switch(gender){
                case "male":
                    return "Laki-laki"
                case "female":
                    return "Perempuan"
                default:
                    return ""
            }
        },
    }
}
</script>